import React, { Component } from "react";
import { message, Spin, Button, Icon, Tabs } from "antd";
import $ from "../../../../common/AjaxRequest";
import API_URL from "../../../../common/url";
import dictCache from '../../../../common/dictCache';
import InvInfor from "./InvInfor.js";
import InvServiceContent from "./InvServiceContent.js";
import ClientParams from ".//ClientParams.js";
import ForecastParams from "./ForecastParams.js";
import VisitingPlan from "./VisitingPlan.js";
import KeyAnalysis from "./KeyAnalysis.js";
import Fetch from "../../../../common/Fetch.js";
import ExportUtil from "../../../../common/ExportUtil.js";
import FTEQuoteRule from "./FTEQuoteRule.js";

const TabPane = Tabs.TabPane;

class ViewPage extends Component {
    state = {
        params: {},
        type: "view",
        visible: false,
        loading: false,
        fileList: [],
        byStageList: [],
        evaluateServeConfigList: [], //项目服务内容
        researchProductTypeList: [],
        activeKey: 'VisitAssess',
        tabs: [],
        recordData: {},
    };

    componentDidMount() {
        this.queryConfigWithChildByType();
        this.loadData();
        this.setTabs();
        this.loadRecordData()
    }

    loadData = () => {
        const { evaluateRecordId } = sessionStorage;
        this.setState({ loading: true });
        const options = {
            method: "POST",
            url: API_URL.evaluate.queryEvaluateServeCustomer,
            data: {
                evaluateRecordId,
            },
            dataType: "json",
            doneResult: (res) => {
                const {
                    data: {
                        evaluateRecordView,//项目基本信息
                        evaluateRecordCustomer,//客户项目参数
                        evaluateServeConfigList, //项目服务内容
                        evaluateRecordServeList,//项目服务内容-选中的值
                    }
                } = res;
                const evaluateRecordServeIds = (evaluateRecordServeList || []).map(el => el.evaluateServeId).join(',');
                this.setState(
                    {
                        params: {
                            evaluateRecordId,
                            ...evaluateRecordView,
                            ...evaluateRecordCustomer,
                            evaluateRecordServeIds,
                            sponsorCompanyName: evaluateRecordView.sponsorName,
                        },
                        loading: false,
                        evaluateServeConfigList,
                    },() => 
                    {
                        // sessionStorage.removeItem('evaluateRecordId');
                        this.handelfirstOption();
                        this.queryEnclosureFileList();
                    }
                );
            },
        }
        $.sendRequest(options);
    }

    loadRecordData = () => {
        const { evaluateRecordId } = sessionStorage;
        const options = {
            method: 'POST',
            url: API_URL.evaluate.queryEvaluateRecords,
            data: {
                evaluateRecordId,
            },
            dataType: 'json',
            doneResult: res => {
                const { datas } = res;
                this.setState({
                    recordData: datas[0] || {},
                });
            }
        };
        $.sendRequest(options);
    }

    setTabs = () => {
        const { quotationType } = sessionStorage
        const { tabs } = this.state;
        if (quotationType == 'VISIT_QUOTATION') {
            tabs.push({
                tab:'访视评估',
                key:'VisitAssess',
            });
        } else if (quotationType == 'FTE_QUOTATION') {
            tabs.push({
                tab:'一口价（建议评估）',
                key:'FTEAssess',
            });
        } else if (quotationType == 'VISIT_FTE_QUOTATION') {
            tabs.push({
                tab:'访视评估',
                key:'VisitAssess',
            },{
                tab:'一口价（建议评估）',
                key:'FTEAssess',
            });
        } else {
            tabs.push({
                tab:'访视评估',
                key:'VisitAssess',
            });
        }
        this.setState({ tabs });
    }

    handelfirstOption = () => {
        const { researchProductTypeList, params } = this.state;
        params[`researchProductTypeIdValue`] = params.researchProductTypePCId ? params.researchProductTypePCId.split(',') : [];
        params[`researchProductTypeIdValue`] = params[`researchProductTypeIdValue`].map(el => el = Number(el));
        if(!!params[`researchProductTypeIdValue`].length) {
            const researchProductTypeItem = researchProductTypeList.find(el => params[`researchProductTypeIdValue`][0] == el.evaluateConfigureId )
            const code = researchProductTypeItem ? researchProductTypeItem.code : undefined;
            if (code) {
                Fetch.post(API_URL.common.queryInvestigationByStageByMedicine, { 
                    investigationMedicineType: code
                })
                    .then(res => {
                        this.setState({ byStageList: res.data });
                    })
                    .catch(error => console.log(error));
            } else {
                this.setState({ byStageList: [] });
            }
        }
    }

    queryEnclosureFileList = () => {
        const { params: { evaluateRecordId } } = this.state
        const options = {
            method: 'POST',
            url: API_URL.evaluate.queryEnclosureFileList,
            data: { 
                relateId: evaluateRecordId,
                uploadType: 'EVALUATE_RECORD_CUSTOMER_FILE'
            },
            dataType: 'json',
            doneResult: res => {
                const fileList = res.datas || [];
                fileList.forEach(item => {
                    item.response = { fileMetaId: item.fileMateId };
                    item.uid = item.fileMateId;
                });
                this.setState({
                    fileList,
                });
            }
        };
        $.sendRequest(options);
    }

    //研究产品类型选项
    queryConfigWithChildByType = () => {
        dictCache.getDict('CONFIG_WITH_CHILD_RESEARCH_PRODUCT_TYPE', cb => {
            $.sendRequest({
                method: 'POST',
                url: API_URL.evaluate.queryConfigWithChildByType,
                data: { type: 'RESEARCH_PRODUCT_TYPE' },
                dataType: 'json',
                doneResult: res => cb(res),
            });
        }, res => {
            this.setState({
                researchProductTypeList: res.list,
            });
        });
    }

    hide = () => {
        this.setState({
            params: {},
            fileList: [],
            visible: false,
            loading: false,
        });
    };

    splitParams = params => {
        const result = {};
        for (const [key, value] of Object.entries(params)) {
            const type = typeof value;
            if (type !== 'object') {
                result[key] = value;
            }
        }
        return result;
    }

    handelRequired = () => {
        const { params } = this.state;
        const InvInforConfig =  this.InvInforRef.handleDomRender();
        const ClientParamsConfig =  this.ClientParamsRef.handleDomRender();
        try {
            InvInforConfig.map(el => {
                const { name, label, type, required = false } = el;
                if(required) {
                    if(type === 'InputNumber' || type === 'Select') {
                        if( params[name] === undefined || params === null || params === '' ) {
                            throw label
                        }
                    } else if(type === 'SearchRetrieve') {
                        if( !params[`${name}Id`] || !params[`${name}Name`]) {
                            throw label
                        }
                    } else if( !params[name] ) {
                        throw label
                    }
                }
            })
            ClientParamsConfig.map(el => {
                const { name, label, type, required = false } = el;
                if(required) {
                    if(type === 'InputNumber' || type === 'Select') {
                        if( params[name] === undefined || params === null || params === '' ) {
                            throw label
                        }
                    } else if( !params[name] ) {
                        throw label
                    }
                }
            })
        } catch (error) {
            message.warning(`请填写${error}！`);
            return false
        }
        return true
    }

    submit = () => {
        const { params, type } = this.state;
        if(!this.handelRequired()) {
            return
        }
        this.setState({ loading: true });
        const options = {
            method: "POST",
            url: API_URL.evaluate.saveEvaluateServeCustomer,
            data: {
                ...this.splitParams(params),
            },
            dataType: "json",
            doneResult: (res) => {
                message.success(res.success);
                this.setState(
                    {
                        loading: false,
                    },
                    () => {
                        this.hide();
                        this.props.loadData();
                    }
                );
            },
            errorResult: () => {
                this.setState({ loading: false });
            },
        };
        $.sendRequest(options);
    };

    handleParamsChange = (params) => {
        this.setState({ params:{
            ...params,
        } });
    };

    handleEvaluateServeChange = (value) => {
        this.setState({ 
            evaluateServeConfigList: JSON.parse(value)
        });
        this.saveEvaluateServeValue(JSON.parse(value))
    }

    saveEvaluateServeValue = (config = []) => {
        const { params } = this.state;
        const evaluateRecordServeIds = [];
        config.map(item => {
            const { children = [] } = item;
            children.map( child => {
                const { children = [] } = child;
                children.map(option => {
                    const { selected, evaluateServeId } = option;
                    if(selected) evaluateRecordServeIds.push(evaluateServeId);
                }) 
            })
        })
        this.setState({
            params: {
                ...params,
                evaluateRecordServeIds: evaluateRecordServeIds.join(',')
            }
        })
    }

    dataExport = () => {
        const { params, activeKey } = this.state;
        const { evaluateRecordId, evaluateSerialNumber } = params;
        const url =  activeKey === 'VisitAssess' ? API_URL.evaluate.exportEvaluateRecordVisit : API_URL.evaluate.exportEvaluateRecordFte;
        ExportUtil.export({ evaluateRecordId, evaluateSerialNumber }, null, url);
        message.success(`开始导出，请在右上角“下载站”中查看导出进度，下载导出文件，请勿重复导出`);
    }

    handleTabClick = (key) => {
        this.setState({ activeKey: key });
    }

    render() {
        const { 
            params, 
            type,
            fileList,
            byStageList,
            evaluateServeConfigList,
            researchProductTypeList,
            activeKey,
            tabs,
            recordData: {
                lineOfBusinessString,  
                researchProductTypeName, 
            },
        } = this.state;
        const {
            evaluateRecordId,
        } = params;
        //以PM、PML身份进入页面
        const record = {
            pmlAuth: true,  //PML
            pmAuth: true,  //PM
            talAuth: false,  //领域leader
            bdBaAuth: false,
            deptBoAuth: false,  //部门BO
            seniorUserAuth: false,  //王总
            lineOfBusinessString,   //业务线
            researchProductTypeName,   //此研究产品类型历史入组速率值tip
        } 
        const { evaluateCode } = sessionStorage;
        const DomArr = [
            {
                title: '项目基本信息',
                show: true,
                Dom: <InvInfor 
                        key='InvInfor'
                        type={type}
                        params={params}
                        byStageList={byStageList}
                        researchProductTypeList={researchProductTypeList}
                        ref={el => this.InvInforRef = el}
                        handleParamsChange={this.handleParamsChange}
                    />
            },
            {
                title: '项目服务内容',
                show: true,
                Dom: <InvServiceContent 
                        key='InvServiceContent'
                        type={type}
                        params={params} 
                        Config={evaluateServeConfigList}
                        handleParamsChange={this.handleParamsChange}
                        handleEvaluateServeChange={this.handleEvaluateServeChange}
                    />
            },
            {
                title: '客户项目参数',
                show: true,
                Dom: <ClientParams 
                        key='ClientParams'
                        type={type}
                        params={params}
                        fileList={fileList}
                        ref={el => this.ClientParamsRef = el}
                        handleParamsChange={this.handleParamsChange}
                        evaluateRecordId={evaluateRecordId}
                        record={record}
                    />
            },
            {
                title: '临床PM参照临床方案预测项目参数',
                key: 'ForecastParams',
                show: type === 'view' && activeKey === 'VisitAssess',
                Dom: <ForecastParams 
                        key='ForecastParams'
                        type={type}
                        showButn={false}
                        evaluateRecordId={evaluateRecordId}
                        record={record}
                    />
            },
            {
                title: '临床PM参照临床方案预测项目方案',
                key: 'VisitingPlan',
                show: type === 'view' && activeKey === 'VisitAssess',
                Dom: <VisitingPlan 
                        key='VisitingPlan'
                        type={type}
                        evaluateRecordId={evaluateRecordId}
                        showClient={false}
                        record={{ pmlAuth: true, pmAuth: true }}
                        showButn={false}
                    />
            },
            {
                title: 'FTE报价规划',
                key: 'VisitingPlan',
                show: type === 'view' && activeKey === 'FTEAssess',
                Dom: <FTEQuoteRule
                        key='FTEQuoteRule'
                        type={type}
                        showButn={false}
                        evaluateRecordId={evaluateRecordId}
                        pageName='viewPage'
                    />
            },
            {
                title: '重点难点分析&其他备注说明',
                key: 'KeyAnalysis',
                show: type === 'view',
                Dom: <KeyAnalysis 
                        key='KeyAnalysis'
                        showButn={false}
                        type={type}
                        evaluateRecordId={evaluateRecordId}
                    />
            },
        ];
        return (
            <div style={{ width: '100%', height: '100%', background: '#ffffff' }}>
                <div style={{ padding: 40 }}>
                <div style={{ overflow: 'hidden' }}>
                    <div style={{ float: 'left', marginBottom: '10px'}}>
                        <i
                            className="icon iconfont"
                            style={{ marginRight: 4, fontSize: '20px', color: '#1296DB'}}
                        >&#xe65b;</i>
                        {`临床评估单号：${evaluateCode}`}
                    </div>
                </div>
                    <Tabs type="card" activeKey={activeKey} onChange={this.handleTabClick}>
                        {tabs.map(pane => <TabPane tab={pane.tab} key={pane.key}></TabPane>)}
                    </Tabs>
                    {
                    DomArr.filter(data => data.show == true).map((el, index) => {
                        return <div>
                                    <div style={{ 
                                        fontSize: 14,
                                        fontWeight: '700',
                                        margin: '10px 0'
                                    }}>
                                        {`${index + 1 }.`}{el.title}
                                    </div>
                                    {el.Dom}
                                </div>
                    })
                }
                </div>
            </div>
        );
    }
}

export default ViewPage;



// WEBPACK FOOTER //
// ./src/components/clinicalEvaluation/clinicalEvaluationRecord/components/ViewPage.js